import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BackgroundImage from "gatsby-background-image"

import EquipTable from "../../components/equipment/equipTable"


const Positioner = ({ data }) => {
  const { file: { image } } = useStaticQuery(graphql`
  {
    file(name: {eq: "positioner"}) {
      image: childImageSharp {
        fluid(quality: 100) {
          originalName,
          ...GatsbyImageSharpFluid
        }
      }
    }
  }`)

  return (
    <section className="positioner">
      <h3>{data.title}</h3>
      <BackgroundImage
        className="image"
        fluid={image.fluid}
        alt={image.originalName}
      />
      <p>{data.description}</p>
      <EquipTable data={data.specifications} />
      <p>{data.p1}</p>
      <p>{data.p2}</p>
    </section>
  )
}

export default Positioner